import AxiosFlexeServeInstance from '../shared/AxiosFlexeServe';
import { ControlUnitAPIResponse } from './ControlUnit.model';

/**
 * Model interface class:
 * this class get the data from the backend for frontend service and use
 * the corresponding class (Group, Device, User, Right) to transfor it
 */
class ControlUnitCalls {
  readonly backendCommanderManagerURL = 'commander';
  constructor(private axios = AxiosFlexeServeInstance) {}

  /**
   * Get events by devices id
   * @param array devicesIds
   */
  async getControlUnitsByDeviceId(deviceId: string, commanderId: string) {
    const url = `${this.backendCommanderManagerURL}/${commanderId}/controlunits`;
    return this.axios.get<ControlUnitAPIResponse[]>(url).then((data) => ({
      id: deviceId,
      controlunits: data.data,
    }));
  }
}

export default ControlUnitCalls;
